import { DiffState, QuantityUpdate } from '../../../hooks/use-product-cart';
import {
  SubscriptionBoxProduct,
  SubscriptionProductItem,
  SubscriptionProductViewItem,
} from '../../../utils/subscriptionDetail/types';
import { BoxProduct } from './BoxProduct';
import { SubscriptionProduct } from './SubscriptionProduct';

type Props = {
  productItem: SubscriptionProductViewItem;
  column: 1 | 2;
  diff: DiffState;
  changeQuantity: (updates: QuantityUpdate | QuantityUpdate[]) => void;
  onClickProductLink: (p: SubscriptionProductItem) => void;
  onClickBoxProductsSelect: (
    box: SubscriptionBoxProduct,
    quantities: Record<string, number>
  ) => void;
  onClickBoxSetContents: (
    box: SubscriptionBoxProduct,
    quantities: Record<string, number>
  ) => void;
};

export function ProductLayout({
  productItem,
  column,
  diff,
  changeQuantity,
  onClickProductLink,
  onClickBoxProductsSelect,
  onClickBoxSetContents,
}: Props) {
  if (productItem.type === 'product') {
    const quantity =
      diff.get(productItem.product.id)?.product.newQuantity ?? productItem.product.quantity;

    return (
      <SubscriptionProduct
        column={column}
        product={productItem.product}
        quantity={quantity}
        changeQuantity={changeQuantity}
        onClickProductLink={onClickProductLink}
      />
    );
  }

  const quantities: Record<string, number> = {};
  let total = 0;
  let isChanged = false;
  for (const item of productItem.box.items) {
    const quantity = diff.get(item.id)?.product.newQuantity ?? item.quantity;
    total += item.currentPriceAmount * quantity;
    quantities[item.id] = quantity;
    if (quantity !== item.quantity) isChanged = true;
  }

  return (
    <BoxProduct
      box={productItem.box}
      total={total}
      isChanged={isChanged}
      quantities={quantities}
      changeQuantity={changeQuantity}
      onClickBoxProductsSelect={onClickBoxProductsSelect}
      onClickBoxSetContents={() => onClickBoxSetContents(productItem.box, quantities)}
    />
  );
}
